import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/compCommon/EFPicture';
// import Close from '@elem/SVGIcon/DeltaProUltra/Close';
import EfSpec from '@elem/ui/ef-spec';
import { useEffect } from 'react';
import CardInfoBtn from './CardInfoBtn';
import { opacity } from 'html2canvas/dist/types/css/property-descriptors/opacity';
import { EfVideo } from '@/element';
import { useMediaDevice } from '@elem/compPage/Oasis/hooks';

export default function B() {
    const { useLang, useState } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [enter, setEnter] = useState(false);
    const [active, setActive] = useState(0);
    const { isH5, isPad } = useMediaDevice();
    let videos: string[] = [
        'https://websiteoss.ecoflow.com/upload/video/1747895135579/backup%2Bapp_1.mp4',
        'https://websiteoss.ecoflow.com/upload/image/1747895589866/Frame%201612707452.jpg',
        'https://websiteoss.ecoflow.com/upload/video/1747895135377/daily%20us_1.mp4',
        'https://websiteoss.ecoflow.com/upload/image/1747895590416/Frame%201612707453.jpg',
    ];
    let videosH5: string[] = [
        'https://websiteoss.ecoflow.com/upload/video/1747895135007/backup-mo_1.mp4',
        'https://websiteoss.ecoflow.com/upload/image/1747895589998/Group%20161269586.jpg',
        'https://websiteoss.ecoflow.com/upload/video/1747895135178/dayly%20us-mo_1.mp4',
        'https://websiteoss.ecoflow.com/upload/image/1747895590208/image.jpg',
    ];

    const tipsData = [
        [
            {
                title: t('secB_icon1_title_1'),
                content: t('secB_icon1_desc_1'),
            },
            {
                title: t('secB_icon1_title_2'),
                content: t('secB_icon1_desc_2'),
            },
            {
                title: t('secB_icon1_title_3'),
                content: t('secB_icon1_desc_3'),
            },
            {
                title: t('secB_icon1_title_4'),
                content: t('secB_icon1_desc_4'),
            },
        ],
        [
            {
                title: t('secB_icon2_title_1'),
                content: t('secB_icon2_desc_1'),
            },
            {
                title: t('secB_icon2_title_2'),
                content: t('secB_icon2_desc_2'),
            },
            {
                title: t('secB_icon2_title_3'),
                content: t('secB_icon2_desc_3'),
            },
            {
                title: t('secB_icon2_title_4'),
                content: t('secB_icon2_desc_4'),
            },
            {
                title: t('secB_icon2_title_5'),
                content: t('secB_icon2_desc_5'),
            },
        ],
    ];

    return (
        <section id="dpu-detail-B" className={`dpu-detail-B dpu-detail-section ${css['dpu-detail-B']}`}>
            <EfSpec />
            <ul className="videos">
                <li className={`video ${active === 0 ? 'active' : ''}`}>
                    <video
                        src={isH5 || isPad ? videosH5[0] : videos[0]}
                        autoPlay={true}
                        loop={true}
                        muted
                        playsInline
                        preload="auto"
                        width="100%"
                        height="100%"
                        poster={isH5 || isPad ? videosH5[1] : videos[1]}
                        aria-label={t('secB_tab1')}
                    />
                    {/* <div className="float-msg">
                        <svg className="light-icon" xmlns="http://www.w3.org/2000/svg" width="11" height="21" viewBox="0 0 11 21" fill="none">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M6.93401 13.8007L10.2631 19.5668L10.8833 19.2087L0.62021 1.43259L0 1.79067L2.7367 6.53077L0.000196251 10.6528H3.76002L2.86483 20.5L6.93401 13.8007ZM7.73947 12.4747L3.57698 5.26502L7.07225 0L6.71417 8.41485H10.2054L7.73947 12.4747Z"
                                fill="white"
                            />
                        </svg>
                        <p className="icon-text">{t('secB_icon')}</p>
                    </div> */}
                    <div className="imgs-box-bottom">
                        {tipsData[0]?.map((item: any, index: number) => {
                            return <CardInfoBtn className={`a${index + 1}`} text={item.title} desc={item?.content} />;
                        })}
                    </div>
                </li>
                <li className={`video ${active === 1 ? 'active' : ''}`}>
                    <video
                        src={isH5 || isPad ? videosH5[2] : videos[2]}
                        autoPlay={true}
                        loop={true}
                        muted
                        playsInline
                        preload="auto"
                        width="100%"
                        height="100%"
                        poster={isH5 || isPad ? videosH5[3] : videos[3]}
                        aria-label={t('secB_tab2')}
                    />
                    <div className="imgs-box-bottom">
                        {tipsData[1]?.map((item: any, index: number) => {
                            return <CardInfoBtn className={`b${index + 1}`} text={item.title} desc={item?.content} />;
                        })}
                    </div>
                </li>
            </ul>
            <ul className="tabs">
                <li className={`tab ${active === 0 ? 'active' : ''}`} onClick={() => setActive(0)}>
                    {t('secB_tab1')}
                </li>

                <li className={`tab ${active === 1 ? 'active' : ''}`} onClick={() => setActive(1)}>
                    {t('secB_tab2')}
                </li>
            </ul>
            <div className="info">
                <h2 className="title">{t(`secB_title${active + 1}`)}</h2>
                <p className="desc">
                    {t.rich(`secB_desc${active + 1}`, {
                        w: (text: any) => <span className="white-text">{text}</span>,
                        n: (text: any) => <span className="no-wrap">{text}</span>,
                        sup: (text: any) => <sup className="sup">{text}</sup>,
                    })}
                </p>
            </div>
            <EfSpec />
        </section>
    );
}
